import { useState, useEffect } from "react"
import axios from "axios"
import api from "./axiosInterceptor.js"

axios.defaults.withCredentials = true

export default function FetchWithParams(url, params, reload, updateReload) {

    const [highLevelStats, setHighLevelStates] = useState({
        data: null,
        error: null,
        load: true
    })
    useEffect(() => {
        console.log('in use effect for params ')
        async function getData() {
            setHighLevelStates((cur) => ({ ...cur, load: true }))
            try {

                const response = await api.get(`api/${url}`, {
                    params: params
                })

                if (response.status === 200) {
                    setHighLevelStates((cur) => ({ ...cur, data: response.data }))
                    // setData(response.data)
                }
                else {
                    updateReload(false)
                    throw response
                }

            } catch (err) {
                updateReload(false)
                setHighLevelStates((cur) => ({ ...cur, error: err }))
                // setError(err)
            } finally {

                updateReload(false)
                setHighLevelStates((cur) => ({ ...cur, load: false }))
                // setLoad(false)
            }
        }
        if (!params) {
            updateReload(false)
        }
        if (params && reload) {
            getData()
        }
        // getData()
    }, [url, reload])
    return { "data": highLevelStats.data, "error": highLevelStats.err, "load": highLevelStats.load }
}

// import api from "./axiosInterceptor.js"
// import { useQuery } from '@tanstack/react-query' // Import useQuery

// // axios.defaults.withCredentials = true

// export default function FetchWithParams(url, params, reload, updateReload) {

//     const fetchData = async () => {
//         const response = await api.get(`api/${url}`, {
//             params: params
//         });
//         return response.data;
//     };

//     const { data, isLoading: load, error } = useQuery({
//         queryKey: [url, params], // Use url and params as part of the query key
//         queryFn: fetchData,
//         enabled: reload && !!params, // Enable query only if reload is true and params are provided
//         // You might want to add more options here, like refetchOnWindowFocus, staleTime, etc.
//     });

//     // The updateReload function from the original hook is no longer directly used to control fetching,
//     // as useQuery handles data fetching and re-fetching based on queryKey changes and enabled state.
//     // However, if there are side effects tied to updateReload, they might need to be re-evaluated.

//     return { "data": data, "error": error, "load": load };
// }